import { z } from 'zod'
export const RefuseRequestTaskSchema = z.object({
	justification: z.string().min(1),
})
